
import React, { useEffect, useState } from 'react'
import axios from "axios";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { Card, Button, ListGroup } from 'react-bootstrap';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getApiHeader } from 'utlis/commonfunctions';
import {  Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import Loader from "./loader";

import tenDollarImage from 'assets/images/prepaidRecharge/RTAP15gb.png';
import thirtyFiveDollarImage from 'assets/images/prepaidRecharge/RTAP45gb.png';
import seventyDollarImage from 'assets/images/prepaidRecharge/RTAP80gb.png';   
import oneHundredTwentyDollarImage from 'assets/images/prepaidRecharge/RTAP120gb.png';
import oneHundredTwentyFiveDollarImage from 'assets/images/prepaidRecharge/$220new.png';
import oneHundredSixtyDollarImage from 'assets/images/prepaidRecharge/RTAP160gb.png';
import twoHundredSixtyDollarImage from 'assets/images/prepaidRecharge/$330.png';


import nintyDollarImage from "assets/images/prepaidRecharge/$39dbdnew.png"
import oneSixtySixtyDollarImage from  "assets/images/prepaidRecharge/$49dbd.png"
import twoFortyDollarImage from "assets/images/prepaidRecharge/$55newdbd.png"
import threeTwentyDollarImage from "assets/images/prepaidRecharge/$60bdbnew.png"
// normal plans 
import normalThirtyFive from "assets/images/prepaidRecharge/$35new.png"
import normalThirtyFiveDBD  from "assets/images/prepaidRecharge/$35dbdnew.png"
import normalFortyFive from "assets/images/prepaidRecharge/$45new.png"


import normalFortyFiveDBD from "assets/images/prepaidRecharge/$45dbdnew.png"

import fiftyfiveHike from "assets/images/prepaidRecharge/$55new.png"    



import fiftyfiveHikeDBD  from   "assets/images/prepaidRecharge/$59dbdnew.png"
import sixtyFour from "assets/images/prepaidRecharge/$60new.png"
import sixtyFourDBD from "assets/images/prepaidRecharge/$64dbdnew.png"      
import DollarTwentyFive  from "../../../../assets/images/prepaidRecharge/$25new.png"

import wme180days from "assets/images/prepaidRecharge/wme180days.webp"
import wme365days from "assets/images/prepaidRecharge/wme365days.webp"
import wme15days from "assets/images/prepaidRecharge/wme15gb.png"

import wme$25 from "assets/images/prepaidRecharge/wme/wme$25.png"
import wme$35 from "assets/images/prepaidRecharge/wme/wme$35.png"
import wme$33 from "assets/images/prepaidRecharge/wme/wme$33.png"
import wme$45 from "assets/images/prepaidRecharge/wme/wme$45.png"




const SERVER_URL = process.env.REACT_APP_API_URL;
function Plans({planData, setSelectedPrepaidPlanId, setSelectedPrepaidPlanName, selectedPrepaidPlanId ,disabled,setDisable,handleBoxclose,open, handlePage}) {

  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [selectedPlanList, setSelectedPlanList] = useState(null);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [cntrList, setCntrList] = useState(false);
  const[showNext,setShowNext]=useState(false)
  // const [selectedPlanId, setSelectedPlanId] = useState(null); // Track the selected plan


  const [referenceNumber, setReferenceNumber] = useState('');
  const [error, setError] = useState('');
  const [isChecking, setIsChecking] = useState(false);
 

  const toggleCountry = (plan_id) => {
    if (cntrList === plan_id) {
      setCntrList(false);
    } else {
      setCntrList(plan_id);
    }
  }

  const handleTypeChange = (planKey) => {
      setSelectedPlanList(planKey);
      console.log(planKey);
      var newPlans = [];
    
      if(planKey === "28"){
        newPlans= planData["plans28"];
      }
      if(planKey === "180"){
        newPlans= planData["plans180"];
      }
      if(planKey === "365"){
        newPlans= planData["plans365"];
      }
      if(planKey === "1000"){
        newPlans= planData["data_only"];
      }
      if(planKey === "2000"){
        newPlans= planData["idd"];
      }
      if(planKey === "3000"){
        newPlans= planData["data_bundle"];
      }
      if(planKey === "4000"){
        newPlans= planData["credit"];
      }
      if(planKey === "5000"){
        newPlans= planData["ir_pack"];
      }
       

    setSelectedPlans(newPlans);
  };







  

  const handleSelectedPrepaidPlanId = (planId,planName) => {
    setSelectedPrepaidPlanId(planId);
    setSelectedPrepaidPlanName(planName);
    handlePage('voucher_count');
  }

  useEffect(() => {
    if (planData && planData.planList) {
      const firstPlanKey = Object.keys(planData.planList)[0];
      setSelectedPlanList(firstPlanKey);
      handleTypeChange(firstPlanKey)
    }

  }, [planData]);

  


  const backPage = () => {
      handlePage('home');
  };






  return (
    <>
      
       <div className="formbold-main-wrapper add-plan-wrapper">
            <div className="formbold-form-wrapper add-plan-form pos-rel">
            <h6>Choose Your Plan</h6>
            <hr />

            {loading === true && (
                    <Loader />
            )}
        
            <br />

      
            <div className="container-fluid mt-4" id="plan-tab-section">
              <section className="country-listing">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 country-tab">
                    <div className="row">
                      <div className="col-md-12 tab-button">
                        <ul className="nav nav-tabs" style={{ backgroundColor: "#fff" }}>
                          {planData?.planList && Object.entries(planData.planList).map(([key, planName]) => (
                            <li
                              key={key}
                              className={selectedPlanList === key ? 'activeplantab' : ''}
                              onClick={() => handleTypeChange(key)}
                            >
                              <span>{planName}</span>
                            </li>
                          ))}
                        </ul>

                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </section>
            </div>

          

            <div className="row ">
          
                {selectedPlans.map((plan, index) => (
                    

                <div className="col-lg-4 col-md-4 col-sm-12 plan-listing"  key={index}>
                  <div
                    key={plan.plan_id}
                    className="add-plan-card"
                  >

                      {(selectedPlanList === "28" || selectedPlanList === "180" || selectedPlanList === "365") ? (
                        <div className="plan-image">
                          {plan.data === "15" && (
                             <>
                              {plan.sell_amount === "25.00" ?
                                <img
                                  src={wme$25}
                                  alt={`Plan ${plan.plan_id}`}
                                  className="img-fluid"
                                />
                                :
                               <>

                                 { plan.plan_id===34?
                                 <img
                                        src={wme15days}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                 :
                                 <img
                                        src={tenDollarImage}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                }
                                  </> 
                              }
                             </>
                          )}


                          {plan.data === "45" && (
                            <>
                              {plan.double_data_eligible ? (
                                <>
                                {plan.sell_amount === "39.90" ?
                                  <img
                                    src={normalThirtyFiveDBD}
                                    alt={`Plan ${plan.plan_id}`}
                                    className="img-fluid"
                                  />
                                  :
                                  <img
                                    src={nintyDollarImage}
                                    alt={`Plan ${plan.plan_id}`}
                                    className="img-fluid"
                                  />
                                }
                              </>
                              ) : (
                                <>  
                                {plan.sell_amount=== "35.00" ?
                                <img
                                src={wme$35}
                                alt={`Plan ${plan.plan_id}`}
                                className="img-fluid"
                              />

                              :
                              <img
                              src={thirtyFiveDollarImage}
                              alt={`Plan ${plan.plan_id}`}
                              className="img-fluid"
                            />
                                }
                                </>
                              )}
                            </>
                          )}


                          {plan.data === "80" && (
                            <>
                              {plan.double_data_eligible ? (
                                 <>
                                 {plan.sell_amount === "49.90" ?
                                   <img
                                     src={normalFortyFiveDBD}
                                     alt={`Plan ${plan.plan_id}`}
                                     className="img-fluid"
                                   />
                                   :
                                   <img
                                     src={oneSixtySixtyDollarImage}
                                     alt={`Plan ${plan.plan_id}`}
                                     className="img-fluid"
                                   />
                                 }
                               </>
                              ) : (
                                 <>
                                    {plan.sell_amount === "45.00" ? (
                                      <img
                                        src={normalFortyFive}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                    ) : plan.sell_amount === "33.00" ? (
                                      <img
                                        src={wme$33}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                    ) : (
                                      <img
                                        src={seventyDollarImage}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                    )}
                                  </>
                              )}
                            </>

                          )}
                          {plan.data === "120" && (
                             <>
                             {plan.double_data_eligible ? (
                                <>
                                  {plan.sell_amount === "59.00" ?
                                    <img
                                      src={fiftyfiveHikeDBD}
                                      alt={`Plan ${plan.plan_id}`}
                                      className="img-fluid"
                                    />
                                    :
                                    <img
                                      src={twoFortyDollarImage}
                                      alt={`Plan ${plan.plan_id}`}
                                      className="img-fluid"
                                    />
                                  }
                                </>
                                ) : (
                                <>
                                  {plan.sell_amount === "55.00" ?
                                    <img
                                      src={fiftyfiveHike}
                                      alt={`Plan ${plan.plan_id}`}
                                      className="img-fluid"
                                    />
                                    :
                                    <img
                                      src={oneHundredTwentyDollarImage}
                                      alt={`Plan ${plan.plan_id}`}
                                      className="img-fluid"
                                    />
                                  }
                                </>
                              )}
                            </>
                          )}

                          {plan.data === "125" && (
                            <img
                              src={oneHundredTwentyFiveDollarImage}
                              alt={`Plan ${plan.plan_id}`}
                              className="img-fluid"
                            />
                          )}

                            {plan.data === "150" && (
                            <img
                              src={wme180days}
                              alt={`Plan ${plan.plan_id}`}
                              className="img-fluid"
                            />
                          )}


                         {plan.data === "160" && (
                            <>
                              {plan.double_data_eligible ? (
                                <>
                                  {plan.sell_amount === "64.90" ?
                                    <img
                                      src={sixtyFourDBD}
                                      alt={`Plan ${plan.plan_id}`}
                                      className="img-fluid"
                                    />
                                    :
                                    <img
                                      src={threeTwentyDollarImage}
                                      alt={`Plan ${plan.plan_id}`}
                                      className="img-fluid"
                                    />
                                  }
                                </>
                              ) : (
                                  <>
                                    {plan.sell_amount === "60.00" ? (
                                      <img
                                        src={sixtyFour}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                    ) : plan.sell_amount === "45.00" ? (
                                      <img
                                        src={wme$45}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                    ) : (
                                      <img
                                        src={oneHundredSixtyDollarImage}
                                        alt={`Plan ${plan.plan_id}`}
                                        className="img-fluid"
                                      />
                                    )}
                                  </>
                              )}
                            </>
                          )}


                          {plan.data === "260" && (

                            <img
                              src={twoHundredSixtyDollarImage}
                              alt={`Plan ${plan.plan_id}`}
                              className="img-fluid"
                            />
                          )}


                           {plan.data === "300" && (

                            <img
                              src={wme365days}
                              alt={`Plan ${plan.plan_id}`}
                              className="img-fluid"
                            />
                          )}





                        </div>
                      ) : (<>
                        <p className="plan-cards-head">{(plan.is_bolt != 2 && plan.is_bolt != 3) ? <>{plan.data}GB data -</> : ''} ${plan.amount}</p>

                        <p className="plan-cards-validity">{((plan.is_bolt === 0) || (plan.is_bolt === 3) || (plan.is_bolt === 4) || (plan.is_bolt === 5)) ? <> {plan.validity} Days Expiry </>: null}

                    {/* {(plan.is_bolt === 7) ? <> {plan.offerName}</>: null} */}

                    {((plan.is_bolt === 2) ) ? <> {Object.keys(plan.idd_countries).length} Destinations </>: null}
                    {((plan.is_bolt === 7) ) ? <> {Object.keys(plan.ir_countries).length} Destinations </>: null}</p>

                    {/* <p className="plan-cards-validity">{plan.validity} Days Expiry</p> */}
                    {(plan.popular_status === "1" && plan.is_bolt === 4) ? <span className="plan-cards-tag">5G Plan</span>: null}
                    {(plan.popular_status == "2" && plan.is_bolt === 0 && plan.plan_account_status ===1) ? <span className="plan-cards-tag">5G Plan</span>: null}
                    </>
)}
                   
                    <ul className='plan-cards-details prepaid-recharge-details'>
                      <ul className="feature_list">

                        {(plan.is_bolt === 0) ?
                          <>
                            {(plan.double_data_eligible) ? (
                              plan.is_activation ? (
                                <li>{plan.data}GB + {plan.data}GB bonus data on activation.</li>
                              ) : (
                                <li>{plan.data}GB + {plan.data}GB bonus data on recharge.</li>
                              )
                            ) : (
                              <li>{plan.data}GB data.</li>
                            )}
                            <li>Unlimited Calls & Text to standard numbers. All for use in Australia.</li>
                            {(plan.extra_credit !== null) ? <li>${plan.extra_credit} Extras Credit for international calls, messages and selected premium SMS services.</li> : null}
                            {/* {((plan.countries) && (Object.keys(plan.countries).length > 0)) ? <li>Unlimited standard international calls & text to {Object.keys(plan.countries).length} Countries.</li> : null} */}
                             
                              {(plan.plan_id === 17 || plan.plan_id === 18 || plan.plan_id === 19) && (
                                <li>Unlimited standard international calls & text to 15 Countries.</li>
                              )}


                            {(plan.popular_status == "2" && plan.plan_account_status == "1") ?
                              <li>5G network access.</li>
                              : <li>4G network access.</li>
                            }

                            {(plan.popular_status == "2" && plan.plan_account_status == "1") ?
                              <li>Download speeds are capped at 150 Mbps on 5G.</li>
                              : ''
                            }

                              {(plan.plan_id === 17 || plan.plan_id === 18 || plan.plan_id === 19 ||  plan.plan_id === 34 || plan.plan_id === 35||plan.plan_id === 36||plan.plan_id === 37 ) ? (
                                <li>Data banking upto 1000GB.</li>
                              ) : (
                                <li>Data banking upto 500GB.</li>
                              )}
                            {(plan.data_gifting_status === "1") ? <li>Gift & Receive Data.</li> : null}
                            {(plan.data_gifting_status === "2") ? <li>Receive Data.</li> : null}
                            {(plan.data_gifting_status === "3") ? <li>Gift Data.</li> : null}
                          </>
                          : null}

                        {(plan.is_bolt === 4) ?
                          <>
                            {(plan.double_data_eligible) ?
                              <li>{plan.data}GB + {plan.data}GB bonus data on activation.</li>
                              :
                              ((plan.double_data_eligible) && (this.props.from !== 'activation') && (this.props.from !== 'add-mobile-plan')) ?
                                <li>{plan.data}GB + {plan.data}GB bonus data on recharge.</li>
                                :
                                <li>{plan.data}GB data.</li>

                            }
                            <li>Unlimited Calls and Text to standard numbers in Australia.</li>
                            {(plan.extra_credit !== null) ? <li>${plan.extra_credit} extras credit for international calls, messages and selected premium SMS Services.</li> : null}
                              
                             {/* {((plan.countries) && (Object.keys(plan.countries).length > 0)) ? <li>Unlimited standard international calls & text to {Object.keys(plan.countries).length} Countries.</li> : null} */}
                                
                              {(plan.plan_id === 14) && (
                                <li>Unlimited standard international calls & text to 15 Countries.</li>
                              )}
                            
                            <li>5G network access.</li>
                            <li>Download speeds are capped at 250 Mbps on 4G & 5G.</li>
                              <li>Data banking upto 1000GB.</li>
                            {(plan.data_gifting_status === "1") ? <li>Gift & Receive Data.</li> : null}
                            {(plan.data_gifting_status === "2") ? <li>Receive Data.</li> : null}
                            {(plan.data_gifting_status === "3") ? <li>Gift Data.</li> : null}
                          </>
                          : null}
                          

                        {(plan.is_bolt === 5) ?
                          <>
                            {(plan.double_data_eligible) ?
                              <li>{plan.data}GB + {plan.data}GB bonus data on recharge.</li>
                              :
                              <li>{plan.data}GB data.</li>
                            }
                            <li>4G network access.</li>
                            <li>No standard/international call or text inclusions</li>
                            {(plan.data_gifting_status === "1") ? <li>Gift & Receive Data.</li> : null}
                            {(plan.data_gifting_status === "2") ? <li>Receive Data.</li> : null}
                            {(plan.data_gifting_status === "3") ? <li>Gift Data.</li> : null}
                          </>
                          : null}

                        {(plan.is_bolt === 2 && plan.idd_pack_id === 3) ?

                          <>

                            <li>
                              No international SMS included.
                            </li>
                            <li>

                              Includes 60 minutes international calls to selected destinations.

                            </li>
                            <li>
                              Expiry - Inline with underlying plan.
                            </li>

                          </>

                          : null}

                        {(plan.is_bolt === 2 && plan.idd_pack_id === 4) ?

                          <>

                            <li>
                              No international SMS included.
                            </li>
                            <li>

                              Includes 120 minutes international calls to selected destinations.

                            </li>
                            <li>
                              Expiry - Inline with underlying plan.
                            </li>

                          </>

                          : null}

                        {(plan.is_bolt === 1) ?

                          <>
                            <li>
                              Includes 1 GB data.
                            </li>

                            <li>
                              Expiry: Inline with underlying plan.
                            </li>

                            <li>
                              Active recharge is required to use Data Bundle.
                            </li>
                          </>

                          : null}


                        {(plan.is_bolt === 7) ?

                          <>
                            <li>7-day validity </li>
                            <li>Voice & Value-Added Services : 30 Mins</li>
                            <li>5GB data</li>
                            <li>30 international SMS to selected destinations</li>
                            <li>Travel pack activates upon entering eligible destinations and uses one of the inclusions (voice calls, SMS, or data)</li>

                          </>

                          : null}
                        {(plan.is_bolt === 3) ?
                          <>

                            {(plan.extra_credit !== null) ? <li>${plan.extra_credit} Extras Credit for international calls, messages and selected premium SMS services.</li> : null}

                          </>
                          : null}

                      </ul>
                    </ul>
               
                    {plan.idd_pack && (
                      <>
                        <p className="plan-cards-country" onClick={() => toggleCountry(plan.plan_id)}>
                          <i className={"fa " + (cntrList === plan.plan_id ? 'fa-chevron-up' : 'fa-chevron-down')} ></i> Country List
                        </p>
                        {cntrList === plan.plan_id && (
                          <div className="contry-list">
                            {JSON.parse(plan.idd_pack.countries).map((country, index) => (
                              <span key={index}>
                                <i className="fa fa-check"></i> {country}
                              </span>
                            ))}
                          </div>
                        )}
                      </>
                    )}

                    {plan.ir_pack && (
                      <>
                        <p className="plan-cards-country" onClick={() => toggleCountry(plan.plan_id)}>
                          <i className={"fa " + (cntrList === plan.plan_id ? 'fa-chevron-up' : 'fa-chevron-down')} ></i> Country List
                        </p>
                        {cntrList === plan.plan_id && (
                          <div className="contry-list">
                            {plan.ir_countries.map((country, index) => (
                              <span key={index}>
                                <i className="fa fa-check"></i> {country}
                              </span>
                            ))}
                          </div>
                        )}
                      </>
                    )}


                    {(plan.plan_id === 16) && (
                      <>
                          <br/>
                          <br/>
                      </>
                    )}

                    <div className='text-center select-btn '>
                      <button
                        // className={`cart-button ${selectedPrepaidPlanId === plan.plan_id ? 'selected' : ''}`}
                        className="cart-button"
                        onClick={() => handleSelectedPrepaidPlanId(plan.plan_id, plan.offerName)}
                      >
    
                             Select Plan
                      </button>
                    </div>

                    <a className="plan-cards-cis" href="https://www.telsim.com.au/critical-information-summary/" target="_blank">Critical Information Summary</a>
                  </div>
                </div>
              ))}
            </div>




            <div className="button-container">
              <button onClick={backPage}>
                Back
              </button>

              

            </div>
          </div>
        </div>
    
    </>
  )
}
export default Plans